<template>
        <div class="head_top">
            <div class="left">
        <img :src="logoImg" alt="">
        <div>跨境贸易大数据平台</div>
      </div>
      <div style="display:flex;align-items:center">
        <div v-if="menuItem.myReport && companyName" class="myReport" style="margin-right:12px" @click="getReportList">
          <img src="@/assets/images/home/report.png" alt="" />
          <div>我的报告</div>
          <div class="report-list" v-if="reportListshow">
            <img src='@/assets/images/home/close.png' @click="closeReportList($event)" class='report-close'/>
            <div class="report-item" @click="download(item)" v-for="(item, index) in reportModelList" :key="index">
              <img src="@/assets/images/home/down.png" />
              <div>{{item.reportName}}</div>
            </div>
            <div v-if="!reportModelList.length">暂无数据~</div>
          </div>
        </div>
        <div class="right" style="cursor: pointer;" @click="showTipes">
          {{form.name}}
          <div class="right-list" v-if="tipsShow">
            <div style="border-bottom:1px solid #fff;cursor: pointer;" @click.stop="singleClick">个人中心</div>
            <div style="cursor: pointer;" @click="loginOut">退出登录</div>
          </div>
        </div>
      </div>
      <el-dialog
      title="个人中心"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class='reportDialog1'
      :visible.sync="sigleShow"
    >
      <div class='mask'></div>
      <div class='ux-panel' style="500px">
        <!-- <div class='title'>个人中心</div> -->
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="登陆账号" prop="dtcUName">
            <el-input v-model="form.fullName" disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-input v-model="form.gender"></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="describe">
            <el-input v-model="form.describe"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input v-model="form.phoneNumber"></el-input>
          </el-form-item>
          <el-form-item label="座机" prop="telephone">
            <el-input v-model="form.telephone"></el-input>
          </el-form-item>
        </el-form>
        <!-- <div class='close' @click='sigleShow = false'>
          <img src='@/assets/images/home/close.png'/>
        </div> -->
      </div>
    </el-dialog>
        </div>
</template>
<script>
import common from '@/utils/common'
import apiPath from '@config/api.json'
const projectData = require('@/utils/projectData.json')
const hostPath = require('@config/host')
export default {
  props: {
    companyName: {
      type: String
    }
  },
  data () {
    return {
      tipsShow: false,
      logoImg: '',
      menuItem: {
        jbxx: false, // 基本信息
        jygl: false, // 经营概览
        jr: false, // 金融
        order: false, // 订单
        wl: true, // 物流
        // ps: false, // 配送
        bg: false, // 报关
        cc: false, // 仓储
        js: false, // 结算
        hasList: false, // 处理是否有以上列表
        myReport: false // 我的报告
      },
      reportListshow: false,
      form: {},
      reportModelList: [],
      sigleShow: false,
      rules: {}
    }
  },
  created () {
    this.logoImg = projectData[hostPath.sysType].logo
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.myReport = common.isShowItem('myReport', setListMenu)
    }
    let data = sessionStorage.getItem('user')
    if (data) {
      data = JSON.parse(data)
    }
    this.form = {
      fullName: data.fullName,
      name: data.name,
      gender: data.gender,
      describe: data.roles.map(item => { return item.describe }).join(','),
      phoneNumber: data.phoneNumber,
      telephone: data.telephone
    }
  },
  methods: {
    closeReportList (e) {
      e.preventDefault()
      setTimeout(() => {
        this.reportListshow = false
      }, 300)
    },
    loginOut () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.common.loginOut}`,
        data: {}
      }).then(res => {
        this.$router.replace('/login')
      })
    },
    download (item) {
      // const a = document.createElement('a')
      // a.setAttribute('href', item.href)
      // a.setAttribute('download', item.title)
      // a.click()
    },
    showTipes () {
      this.tipsShow = true
    },
    singleClick () {
      this.tipsShow = false
      this.sigleShow = true
      this.$forceUpdate()
    },
    getReportList () {
      if (this.reportListshow) return
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.listReportBase}`,
        data: {
          customerName: this.companyName
        }
      }).then(res => {
        this.reportModelList = res.data
        this.reportListshow = true
      }).catch(e => {
      })
    }
  }
}
</script>
<style lang="scss" scoped>
 .head_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding:0 16px;
      height: 40px;
      font-size: 18px;
      margin-top:16px;
      .left{
        display: flex;
        align-items: center;
      }
      .right{
        display: flex;
        align-items: center;
        width: 137px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        padding-left: 58px;
        color: #E2F0FE;
        background: url('~@/assets/images/home/out.png') no-repeat 0 0;
        .right-list{
          position: absolute;
          right: 22px;
          top: 66px;
          width: 188px;
          border-radius: 8px;
          background: rgba(71, 90, 179, 0.8);
          z-index: 999;
          div{
            height:35px;
            line-height: 35px;
            width: 188px;
            text-align: center;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/heads.vue